import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Button,
  Divider,
  MenuItem,
  Menu,
  Drawer,
  Typography,
  IconButton,
  Box,
  Tooltip,
  DialogActions,
  Dialog,
  Chip,
  Stack,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store/appStore";
import { STATUS } from "../../utils/status";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { TableCellBody, TableCellHead } from "../table/tableCell";
import PaginationEntries from "../pagination/paginationEntries";
import { useStyles } from "../../assets/styles/listTableStyle";
import DeleteModal from "../modal/deleteModal";
import {
  getUploadTaskPage,
  updateUpload,
  createAllocation,
} from "../../redux/slices/upload";
import Error from "../error/error";
import Pagination from "./taskPagination";
import AllocationModal from "./allocateModal";
import InfoModal from "./infoModal";
import { setIds } from "../../redux/reducers/taskIdSlice";
import ConfirmationDialog from "./confirmationModal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { clearEmails } from "../../redux/reducers/selectedEmail";
import SnackbarNotification from "../snackbar/snackbarNotification";
import InfoModalReview from "./infoModalReview";
import { clearEmailss } from "../../redux/reducers/selectedEmailReviewer";
import TaskCompleted from "../taskCompleted/taskCompleted";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import debounce from "lodash.debounce";
import { getVendorAction } from "../../redux/slices/vendor";
import { getTaskData, setGetTaskDataStatus } from "../../redux/slices/taskData";
import InfoModelTaskUnallocation from "./infoModelTaskUnallocation";
import {
  getConfigsData,
  setGetConfigDataStatus,
} from "../../redux/slices/config";
import Filter from "../Filters/Filter";
import { setCreateMetaQC } from "../../redux/slices/upload";
import { setCreateAllocationStatus } from "../../redux/slices/allocation";
import { getReview } from "../../redux/slices/reviewerSlice";
import {
  getOutputJsonTaskStatus,
  setTaskStatus,
} from "../../redux/slices/outputJson";
import { usePollingTaskStatus } from "../outputJson/usePollingStatus";
import ExportCompletedTasksDialog from "../Exported Completed task Dialogue box/ExportCompletedTasksDialog";
import ExportTaskDialog from "../Exported Completed task Dialogue box/ExportTaskDialog";
import DrawerFilters from "../Filters In Drawer/DrawerFilters";
import { drawerFilter, Option } from "../../utils/types";
import TaskTable from "./taskPageTable";
import {
  PlayCircleOutline,
  CheckCircleOutline,
  CancelOutlined,
  Cached,
  VisibilityOutlined,
  RadioButtonUnchecked,
  EditNote,
} from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import TaskStatusModal from "../outputJson/taskStatusModal";
import { TableCellWithPopover } from "../table/StatusCellPopover";
import { getTaskExperts } from "../../redux/slices/expertSlice/addExpertSlice";
import { error } from "console";

const getUniqueTaskers = (taskers: any[]) => {
  const uniqueTaskers: any[] = [];
  const seenEmails = new Set<string>();

  taskers &&
    taskers.forEach((tasker) => {
      if (!seenEmails.has(tasker.email)) {
        uniqueTaskers.push(tasker);
        seenEmails.add(tasker.email);
      }
    });

  return uniqueTaskers;
};

type StatusKey =
  | "Not Started"
  | "Active"
  | "Completed"
  | "Quality Accepted"
  | "Quality Reject"
  | "Awaiting Task Update"
  | "Awaiting Review"
  | "Draft";

const statusIcons: Record<StatusKey, JSX.Element> = {
  "Not Started": <RadioButtonUnchecked color="disabled" />,
  "Active": <PlayCircleOutline color="primary" />,
  "Completed": <CheckIcon sx={{ color: "green" }} />,
  "Quality Accepted": <CheckCircleOutline sx={{ color: "green" }} />,
  "Quality Reject": <CancelOutlined sx={{ color: "red" }} />,
  "Awaiting Task Update": <Cached sx={{ color: "orange" }} />,
  "Awaiting Review": <VisibilityOutlined sx={{ color: "purple" }} />,
  "Draft": <EditNote sx={{ color: "#607D8B" }} />,
};

interface Filters {
  taskName: string;
  taskAllocation: string;
  reviewAllocation: string;
  pseudoname: string;
  selectedVendor: string;
  selectedTaskType: any;
  selectedStatus: any;
}

const TaskUploadTable = () => {
  const classes = useStyles();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<string>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOption] = useState("");
  const [currentPage, setCurrentPage]: any = useState(1);
  const [itemsPerPage, setItemsPerPage]: any = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [openInfoModalReview, setOpenInfoModalReview] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);
  const getTaskStatus = useSelector(
    (state: RootState) => state.upload.getUploadTaskStatus
  );
  const { getTaskDataStatus, taskData } = useSelector(
    (state: RootState) => state.taskData
  );
  const selectedEmails = useSelector(
    (state: RootState) => state.selectedEmails
  );
  const selectedEmailsReview = useSelector(
    (state: RootState) => state.selectedEmailsReview
  );
  const deadline = useSelector((state: RootState) => state.deadline.deadline);
  const selectedIds = useSelector(
    (state: RootState) => state.tasks.selectedIds
  );
  const upload = useSelector((state: RootState) => state.upload.uploadTask);
  const [filteredTaskers, setFilteredTaskers] = useState<any[]>([]);
  const [filteredReviewers, setFilteredReviewers] = useState<any[]>([]);
  const [allocationType] = useState("");
  const selectedTasksWithoutAllocation = useSelector(
    (state: RootState) => state.allocationTask.tasksWithoutAllocation
  );
  const selectedTasksWithAllocation = useSelector(
    (state: RootState) => state.allocationTask.tasksWithAllocation
  );
  const selectedReviewsWithoutAllocation = useSelector(
    (state: RootState) => state.allocationTask.reviewWithoutAllocation
  );
  const fetchPermissions = useSelector(
    (state: RootState) => state.projects.permissions
  );
  const association_type = useSelector(
    (state: RootState) => state.projects.association_type
  );
  const association_type_company =
    association_type && association_type === "COMPANY" ? true : false;
  const association_type_vendor =
    association_type && association_type === "VENDOR" ? true : false;
  const [isUnsavedModalOpen, setIsUnsavedModalOpen] = useState(false);

  const { taskers: tasker_wrapper } = useSelector(
    (state: RootState) => state.projects.projects as any
  );
  const { reviewers: reviewer_wrapper, project: projectDetails } = useSelector(
    (state: RootState) => state.projects as any
  );
  const { getConfigDataStatus, configData } = useSelector(
    (state: RootState) => state.configData
  );
  const getConfigDataMessage = useSelector(
    (state: RootState) => state.configData.getConfigsDataMessage
  );

  let taskers =
    tasker_wrapper && tasker_wrapper.map((tasker: any) => tasker.expert);
  taskers = getUniqueTaskers(taskers);

  let reviewers =
    reviewer_wrapper === undefined
      ? []
      : reviewer_wrapper.map((reviewer: any) => reviewer.expert);
  reviewers = getUniqueTaskers(reviewers);

  const Vendors = useSelector((state: RootState) => state.vendors.vendors);
  const getVendorStatus = useSelector(
    (state: RootState) => state.vendors.getVendorsStatus
  );
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    "success" | "error" | "info" | "warning"
  >("success");
  const createStatus = useSelector(
    (state: RootState) => state.allocation.createStatus
  );

  const createError = useSelector(
    (state: RootState) => state.upload.createAllocationMessage
  );
  const createFailedError = useSelector(
    (state: RootState) => state.upload.createAllocationFailedMessage
  );
  const createMetaQCStatus = useSelector(
    (state: RootState) => state.upload.createMetaQCStatus
  );
  let [type] = useState("");
  const [drawer, setDrawer] = useState(false);
  const [currentTaskID, setcurrentTaskID] = useState<string>("");
  const [anchorE2, setAnchorE2] = useState(null);
  const [anchorE3, setAnchorE3] = useState(null);
  const [selectedValue] = useState("");
  const [value, setValue] = useState("1");
  const [searchType, setSearchType] = useState("");
  const [taskName, setTaskName]: any = useState("");
  const [taskerName, setTaskerName] = useState("");
  const [taskAllocation, setTaskAllocation] = useState("");
  const [reviewAllocation, setReviewAllocation] = useState("");
  const [pseudoname, setPseudoName] = useState("");
  const [filterCount, setFilterCount]: any = useState(0);
  const [filterCountApplied, setFilterCountApplied]: any = useState(0);
  const [filterInFocus, setfilterInFocus] = useState("");
  const [appliedFilterValues, setAppliedFilterValues] = useState<string[]>([]);
  const [byTaskListOpen, setByTaskListOpen] = useState(false);
  const [byReviewListOpen, setByReviewListOpen] = useState(false);
  const [vendorId, setVendorId] = useState("");
  const [options, setOptions] = useState<any[]>([]);
  const [open, setOpen] = React.useState(false);
  const [openAutoComplete, setOpenAutoComplete] = React.useState(false);
  const [selectedVendor, setSelectedVendor] = useState<any>(null);
  const [selectedTaskType, setSelectedTaskType]: any = useState(null);
  const [selectedNewTaskType, setSelectedNewTaskType] = useState<string[]>([]);
  const [selectedStatus, setSelectedStatus]: any = useState<string[]>([]);
  const [searchTermAutocomplete, setSearchTermAutocomplete] = useState("");
  const [bySelectVendorOpen, setBySelectVendorOpen] = useState(false);
  const [taskNameListOpen, setTaskNameListOpen] = useState(false);
  const [taskEmailNameListOpen, setTaskEmailNameListOpen] = useState(false);
  const [openList, setOpenList] = useState<string | null>(null);
  const {
    getTaskStatusOutputJson,
    getTaskStatusOutputJsonMessage,
    taskStatusOutputJsonResponse,
  } = useSelector((state: RootState) => state.outputJson);
  const [openTaskStatusModal, setOpenTaskStatusModal] = useState(false);
  const [openTaskUnallocationModel, setOpenTaskUnallocationModel]: any =
    useState(false);
  const [openReviewUnallocationModel, setOpenReviewUnallocationModel]: any =
    useState(false);
  const updateCompletedTaskStatus = useSelector(
    (state: RootState) => state.upload.updateCompletedTaskStatus
  );
  const updateCompletedTaskMessage = useSelector(
    (state: RootState) => state.upload.updateCompletedTaskMessage
  );
  const getTaskDataMessage = useSelector(
    (state: RootState) => state.taskData.getTaskDataMessage
  );
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedStage, setSelectedStage] = useState<string | null>(null);
  const [metaQcStatus, setMetaQcStatus] = useState("");
  const getReviewStatus = useSelector(
    (state: RootState) => state.reviewStage.getReviewStatus
  );
  const getReviewStages = useSelector(
    (state: RootState) => state.reviewStage.reviewer
  );
  const reviewStages = useSelector(
    (state: RootState) => state.reviewStage.reviewer.results
  );
  const [filterTypes, setFilterType] = useState("");
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const filterFromUrl = searchParams.get("reviewStage") || "OPEN";
  const [selectedChip, setSelectedChip] = useState<string>(filterFromUrl);

  // Auto-open task drawer when navigated here from another page with openTaskId param
  useEffect(() => {
    const openTaskId = searchParams.get('openTaskId');
    if (openTaskId) {
      setDrawer(true);
      setcurrentTaskID(openTaskId);
      // Remove the param from URL without re-navigating
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.delete('openTaskId');
        return next;
      }, { replace: true });
    }
  }, [searchParams]);
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [openNewExportDialog, setOpenNewExportDialog] = useState(false);
  const [statusList, setStatusList] = useState<string[]>([]);
  const [openDrawerFilter, setOpenDrawerFilter] = useState(false);
  const [appliedValues, setAppliedValues] = useState<{
    taskName?: string;
    stage?: string;
    statusList?: string[];
    statusStageId?: string;
    selectedTaskType?: any;
    expertId?: string;
    gigSourceId?: string;
    vendorId?: string;
    vendorPseudoName?: string;
  }>({});
  const [statusStageId, setStatusStageId] = useState("");
  const [gigSourceId, setGigSourceId] = useState("");
  const [expertId, setExpertId] = useState("");
  const [vendorPseudoName, setVendorPseudoName] = useState("");
  const [downloadTaskId, setDownloadTaskId] = useState<string | undefined>(
    undefined
  );
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [downloadInitiated, setDownloadInitiated] = useState(false);
  const [previousTaskDataStatus, setPreviousTaskDataStatus] = useState<string | null>(null);
  const [previousTaskStatusOutputJsonStatus, setPreviousTaskStatusOutputJsonStatus] = useState<string | null>(null);

  const handleExportDialogOpen = () => {
    setOpenExportDialog(true);
    setAnchorE2(null);
  };
  const handleExportDialogClose = () => setOpenExportDialog(false);

  const taskStatusOptions: Option[] = [
    { label: "Active", value: "ACTIVE" },
    { label: "Not Started", value: "NOT STARTED" },
    { label: "Quality Accepted", value: "QUALITY ACCEPTED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Awaiting Review", value: "AWAITING REVIEW" },
    { label: "Quality Reject", value: "QUALITY REJECT" },
    { label: "Draft", value: "DRAFT" },
  ];

  const reviewStatusOptions: Option[] = [
    { label: "Active", value: "ACTIVE" },
    { label: "Not Started", value: "NOT STARTED" },
    { label: "Quality Accepted", value: "QUALITY ACCEPTED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Awaiting Task Update", value: "AWAITING TASK UPDATE" },
    {label: "Quality Reject", value: "QUALITY REJECT" },
    { label: "Awaiting Review", value: "AWAITING REVIEW" },
    { label: "Draft", value: "DRAFT" },
  ];

  useEffect(() => {
    dispatch(
      getVendorAction({
        is_vendorblock: false,
        search_query: searchTermAutocomplete,
      })
    );
  }, [dispatch, searchTermAutocomplete]);

  useEffect(() => {
    const payload: any = {
      // search: searchTerm.trim(),
      task_name: appliedValues.taskName?.trim() || "",
      expert_email: taskAllocation.trim(),
      project_id: id || "",
      page: currentPage,
      // type: buildTypeParam(filterTypes, selectedNewTaskType),
      pageSize: itemsPerPage,
      statuses: appliedValues.statusList || [],
      vendor_id: appliedValues.vendorId || "",
      ...(selectedStage && { allocated_task_type: "REVIEW" }),
      stage_id: appliedValues.statusStageId || "",
      allocated_task_type: appliedValues.selectedTaskType || null,
      task_allocation_status: appliedValues.statusList || [],
      expert: appliedValues.expertId || "",
      gig_source_id: appliedValues.gigSourceId || "",
    };

    dispatch(getUploadTaskPage(payload));
  }, [filterTypes, currentPage, itemsPerPage, appliedValues]);

  useEffect(() => {
    dispatch(
      getVendorAction({
        is_vendorblock: false,
        search_query: searchTermAutocomplete,
      })
    );
  }, [dispatch, searchTermAutocomplete]);

  useEffect(() => {
    const handleCreateStatus = () => {
      // if (createStatus === STATUS.SUCESS) {
      // dispatch(getUpload(
      //   {
      //     project_id: id || '',
      //     pageSize: itemsPerPage
      //   }))
      // }

      if (createStatus === STATUS.FAILED) {
        handleSnackbar("Error Occurred, Please try again!", "error");
      }
    };

    handleCreateStatus();
    return () => {
      if (createStatus === STATUS.SUCESS || createStatus === STATUS.FAILED) {
        dispatch(setCreateAllocationStatus(STATUS.NOT_STARTED));
      }
    };
  }, [createStatus, navigate, dispatch]);

  useEffect(() => {
    const handleCreateStatus = () => {
      if (updateCompletedTaskStatus === STATUS.SUCESS) {
        handleSnackbar(updateCompletedTaskMessage || "Success", "success");
        dispatch(
          getUploadTaskPage({
            project_id: id || "",
            pageSize: itemsPerPage,
          })
        );
      }

      if (updateCompletedTaskStatus === STATUS.FAILED) {
        handleSnackbar(updateCompletedTaskMessage || "Success", "error");
      }
    };
    handleCreateStatus();
    return () => {
      if (
        updateCompletedTaskStatus === STATUS.SUCESS ||
        updateCompletedTaskStatus === STATUS.FAILED
      ) {
        dispatch(setCreateAllocationStatus(STATUS.NOT_STARTED));
      }
    };
  }, [updateCompletedTaskStatus, navigate, dispatch]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleTaskNameToggle = (listName: string) => {
    setTaskNameListOpen(!taskNameListOpen);
    setfilterInFocus("task_name");
    setOpenList((prev) => (prev === listName ? null : listName));
  };
  const resetTaskName = () => {
    setTaskName("");
  };

  const handleTaskEmailNameToggle = (listName: string) => {
    setTaskEmailNameListOpen(!taskEmailNameListOpen);
    setfilterInFocus("task_allocation");
    setOpenList((prev) => (prev === listName ? null : listName));
  };
  const resetTaskEmailName = () => {
    setTaskAllocation("");
  };

  const resetTaskType = () => {
    setSelectedTaskType(null);
    setByTaskListOpen(false);
  };
  const resetStatus = () => {
    setSelectedStatus([]);
    setByReviewListOpen(false);
  };
  const resetSelectVendor = () => {
    setSearchTermAutocomplete("");
    setSelectedVendor(null);
    setBySelectVendorOpen(false);
    setVendorId("");
  };

  // List Open Close
  const handleByTaskListClick = (listName: string) => {
    setByTaskListOpen(!byTaskListOpen);
    setfilterInFocus("by_task_list_open");
    setOpenList((prev) => (prev === listName ? null : listName));
  };
  const handleByReviewListClick = (listName: string) => {
    setByReviewListOpen(!byReviewListOpen);
    setfilterInFocus("by_review_list_open");
    setOpenList((prev) => (prev === listName ? null : listName));
  };
  const handleBySelectVendorClick = (listName: string) => {
    setBySelectVendorOpen(!bySelectVendorOpen);
    setfilterInFocus("by_select_vendor_open");
    setOpenList((prev) => (prev === listName ? null : listName));
  };

  const handleSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning"
  ) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleMenuClick = (event: any) => {
    setAnchorE2(event.currentTarget);
  };

  const handleMenuItemClick = (option: string) => {
    switch (option) {
      case "Task Allocation":
        handleOpenVideoModal(option);
        break;
      case "Unallocation":
        handleOpenVideoModal(option);
        break;
      case "Review Allocation":
        handleOpenVideoModal(option);
        break;
      case "Review Unallocation":
        handleOpenVideoModal(option);
        break;
      case "Download Task Data":
        handleDownloadBtn();
        break;
      case "Upload Task":
        handleAddClick();
        break;
      case "Delivered Task":
        handleDeliveredAddClick();
        break;
      case "Upload Json":
        handleUploadJsonClick();
        break;
      case "Export Json":
        handleExportJsonClick();
        break;
      case "Config Data":
        //handleExportDialogOpen();

        handleConfigData();
        break;
      case "Bulk Task Delete":
        handleBulkTaskDelete();
        break;
      case "Run Script":
        handleRunScriptClick();
        break;
      default:
        break;
    }
  };

  const getStatusIcon = (status: string) => {
    if (!status) return "-";

    const match = Object.keys(statusIcons).find(
      key => key.toLowerCase() === status.toLowerCase()
    ) as StatusKey | undefined;

    return match ? statusIcons[match] : "-";
  };

  const handleMenuClose = () => {
    setAnchorE2(null);
  };

  const buildTypeParam = (
    filterTypes: string,
    selectedNewTaskType: (string | null | undefined)[]
  ): string => {
    const allValues = [filterTypes, ...selectedNewTaskType];
    const cleanedValues = allValues.filter(
      (val): val is string => typeof val === "string" && val.trim() !== ""
    );
    return cleanedValues.join(",");
  };

  const redirectingAllocationPage = (option?: string) => {
    // console.log(option)
    navigate(`/allocation/${id}/${option}`);
  };

  const handleOpenVideoModal = (option: string) => {
    if (option === "Task Allocation") {
      redirectingAllocationPage(option);
    }
    if (option === "Unallocation") {
      redirectingAllocationPage(option);
    }
    if (option === "Review Allocation") {
      redirectingAllocationPage(option);
    }
    if (option === "Review Unallocation") {
      redirectingAllocationPage(option);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);

    if (allocationType === "TASK") {
      dispatch(clearEmails());
    } else {
      dispatch(clearEmailss());
    }

    if (allocationType === "TASK") {
      setOpenInfoModal(true);
    } else {
      setOpenInfoModalReview(true);
    }
  };

  const handleCloseInfoModal = () => {
    setOpenInfoModal(false);
  };

  const handleCloseInfoModalReview = () => {
    setOpenInfoModalReview(false);
  };

  const handleCancelConfirmation = () => {
    setOpenConfirmationDialog(false);
    setOpenModal(true);
  };

  const handleEmailClick = (email: string) => {
    setSelectedEmail(email);
  };

  const handleAllocateClick = () => {
    setOpenConfirmationDialog(true);
    setOpenModal(false);
    setOpenInfoModal(false);
    setOpenInfoModalReview(false);
  };

  const handleConfirmAllocation = () => {
    const payload = {
      project_id: id,
      task_ids:
        allocationType === "TASK"
          ? selectedTasksWithoutAllocation.map((task: any) => task.id)
          : allocationType === "REVIEW"
            ? selectedTasksWithAllocation
              .filter((task) =>
                selectedReviewsWithoutAllocation.some(
                  (review) => review.id === task.id
                )
              )
              .map((task) => task.id)
            : [],
      expert_ids:
        allocationType === "TASK" ? selectedEmails : selectedEmailsReview,
      type: allocationType,
      deadline: deadline,
      action: "assign",
    };

    dispatch(createAllocation(payload));
    handleCloseModal();
    setOpenInfoModal(false);
    setOpenInfoModalReview(false);
    setOpenConfirmationDialog(false);
  };

  useEffect(() => {
    if (createStatus === STATUS.SUCESS) {
      handleSnackbar(
        createFailedError !== "" ? createFailedError : createError,
        createFailedError !== "" ? "error" : "success"
      );

      // window.location.reload()
      //dispatch(getUpload({ search: searchTerm, project_id: id || '', pageSize: itemsPerPage, page: currentPage, type: type }))
    }

    if (createStatus === STATUS.FAILED) {
      handleSnackbar(createError, "error");
    }
    return () => {
      if (createStatus === STATUS.SUCESS || createStatus === STATUS.FAILED) {
        dispatch(setCreateAllocationStatus(STATUS.NOT_STARTED));
      }
    };
  }, [createStatus, navigate, dispatch]);

  useEffect(() => {
    const handleGetStatus = () => {
      if (getTaskStatus === STATUS.PENDING) {
        setLoading(true);
      }
      if (getTaskStatus === STATUS.SUCESS) {
        setLoading(false);
      }
      if (getTaskStatus === STATUS.FAILED) {
        setLoading(true);
      }
    };

    handleGetStatus();
  }, [getTaskStatus]);

  const handleNextClick = () => {
    setOpenModal(true);
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPage(1);
    setSearchTerm(event.target.value.trim());
  };
  const handleSearchChangeAutoComplete = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchTermAutocomplete(event.target.value.trim());
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteClick = (userId: string) => {
    setUserIdToDelete(userId);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setShowDeleteModal(false);
    try {
      await dispatch(updateUpload({ id: userIdToDelete, is_deleted: true }));
      dispatch(
        getUploadTaskPage({
          task_name: searchTerm,
          project_id: id || "",
          pageSize: itemsPerPage,
          page: currentPage,
        })
      );
    } catch (error) {
      console.error("Failed to delete config", error);
    }
  };

  useEffect(() => {
    if (allocationType === "TASK") {
      setFilteredTaskers(
        taskers.filter(
          (tasker: { name: string; email: string }) =>
            tasker.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            tasker.email?.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    } else if (allocationType === "REVIEW") {
      setFilteredReviewers(
        reviewers.filter(
          (reviewer: { name: string; email: string }) =>
            reviewer.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            reviewer.email?.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [searchQuery, allocationType, type]);

  const handleAddClick = () => {
    navigate(`/uploadtask/${id}`);
  };

  const handleBulkTaskDelete = () => {
    navigate(`/bulktaskdelete/${id}`);
  };

  const handleDeliveredAddClick = () => {
    navigate(`/deliveredTask/${id}`);
  };

  const handleUploadJsonClick = () => {
    navigate(`/uploadtask/${id}?json`);
  };

  const handleExportJsonClick = () => {
    navigate(`/exportjson/${id}?export`);
  };

  const handleRunScriptClick = () => {
    navigate(`/runscript/${id}`);
  };

  const handleChangeRowsPerPage = (value: number) => {
    setItemsPerPage(value as number);
    setCurrentPage(1);
  };

  const headers = [
    "TASK NAME",
    (association_type_vendor &&
      ((Object.keys(fetchPermissions).includes("task_allocation_single") &&
        fetchPermissions["task_allocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_allocation_bulk") &&
          fetchPermissions["task_allocation_bulk"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_unallocation_single") &&
          fetchPermissions["task_unallocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_unallocation_bulk") &&
          fetchPermissions["task_unallocation_bulk"][0] === true))) ||
      (association_type_company &&
        Object.keys(fetchPermissions).includes("task_allocation") &&
        fetchPermissions["task_allocation"][0] === true)
      ? "TASK STATUS"
      : undefined,

    selectedTaskType === "REVIEW" &&
      ((association_type_vendor &&
        ((Object.keys(fetchPermissions).includes("review_allocation_single") &&
          fetchPermissions["review_allocation_single"][0] === true) ||
          (Object.keys(fetchPermissions).includes("review_unallocation_single") &&
            fetchPermissions["review_unallocation_single"][0] === true) ||
          (Object.keys(fetchPermissions).includes("review_unallocation_bulk") &&
            fetchPermissions["review_unallocation_bulk"][0] === true))) ||
        (association_type_company &&
          Object.keys(fetchPermissions).includes("review_allocation") &&
          fetchPermissions["review_allocation"][0] === true))
      ? "REVIEW STATUS"
      : undefined,

    (association_type_vendor &&
      ((Object.keys(fetchPermissions).includes("task_allocation_single") &&
        fetchPermissions["task_allocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_allocation_bulk") &&
          fetchPermissions["task_allocation_bulk"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_unallocation_single") &&
          fetchPermissions["task_unallocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_unallocation_bulk") &&
          fetchPermissions["task_unallocation_bulk"][0] === true))) ||
      (association_type_company &&
        Object.keys(fetchPermissions).includes("task_allocation") &&
        fetchPermissions["task_allocation"][0] == true)
      ? "TASKER PSEUDO NAME"
      : undefined,

    (association_type_vendor &&
      ((Object.keys(fetchPermissions).includes("task_allocation_single") &&
        fetchPermissions["task_allocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_allocation_bulk") &&
          fetchPermissions["task_allocation_bulk"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_unallocation_single") &&
          fetchPermissions["task_unallocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("task_unallocation_bulk") &&
          fetchPermissions["task_unallocation_bulk"][0] === true))) ||
      (association_type_company &&
        Object.keys(fetchPermissions).includes("task_allocation") &&
        fetchPermissions["task_allocation"][0] == true)
      ? "TASKER ALLOCATION"
      : undefined,

    (association_type_vendor &&
      ((Object.keys(fetchPermissions).includes("reivew_allocation_single") &&
        fetchPermissions["review_allocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("review_allocation_bulk") &&
          fetchPermissions["review_allocation_bulk"][0] === true) ||
        (Object.keys(fetchPermissions).includes("review_unallocation_single") &&
          fetchPermissions["review_unallocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("review_unallocation_bulk") &&
          fetchPermissions["review_unallocation_bulk"][0] === true))) ||
      (association_type_company &&
        Object.keys(fetchPermissions).includes("review_allocation") &&
        fetchPermissions["review_allocation"][0] == true)
      ? "REVIEWER PSEUDO NAME"
      : undefined,

    (association_type_vendor &&
      ((Object.keys(fetchPermissions).includes("review_allocation_single") &&
        fetchPermissions["review_allocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("review_unallocation_single") &&
          fetchPermissions["review_unallocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("review_unallocation_single") &&
          fetchPermissions["review_unallocation_single"][0] === true) ||
        (Object.keys(fetchPermissions).includes("review_unallocation_bulk") &&
          fetchPermissions["review_unallocation_bulk"][0] === true))) ||
      (association_type_company &&
        Object.keys(fetchPermissions).includes("review_allocation") &&
        fetchPermissions["review_allocation"][0] == true)
      ? "REVIEW ALLOCATION"
      : undefined,

    filterTypes === "ALLOCATED" && !association_type_vendor
      ? "REJECTION STAGE"
      : undefined,

    filterTypes === "ALLOCATED" && association_type_vendor
      ? "REJECTION STAGE"
      : undefined,

    !association_type_vendor ? "ACTIONS" : undefined,
  ].filter((header) => header != undefined);

  const totalPages = Math.ceil((upload.count || 0) / itemsPerPage);

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleSearchAllocation = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchQuery(event.target.value);
  };

  const handleDoneClick = () => {
    if (selectedOption === "One") {
      const allIds = (upload.results || []).map((row: any) => ({
        id: row.id,
        task_name: row.task_name,
      }));
      dispatch(setIds(allIds));
    } else {
      dispatch(setIds([]));
    }
    handleClosePopover();
  };

  useEffect(() => {
    handleDoneClick();
  }, [selectedOption]);

  const handleDownloadBtn = async () => {
    setDownloadInitiated(true);
    const res = await dispatch(
      getTaskData({ project_id: id, association_type })
    );
    const taskId =
      res?.payload?.data?.task_id || res?.payload?.data?.data?.task_id;
    if (taskId) {
      setDownloadTaskId(taskId);
      dispatch(getOutputJsonTaskStatus({ celery_task_id: taskId }));
    }
  };

  const handleConfigData = () => {
    setOpenNewExportDialog(true);
    setAnchorE2(null);
  };

  const handleClick = (event: any) => {
    // setAnchorE3(event.currentTarget);
    setOpenDrawerFilter(true);
  };

  const handleApplyClick = () => {

    // === Validation Rules ===
    if (!taskName && !statusList.length && !expertId && !gigSourceId && !vendorId && !vendorPseudoName && !statusStageId) {
      handleSnackbar("Please select at least one filter before applying.", "error");
      return;
    }

    // Task Name without Stage
    // if (taskName && !statusStageId) {
    //   handleSnackbar("Please select a stage when filtering by Task Name.", "error");
    //   return;
    // }

    // Status without Stage
    if (statusList.length > 0 && !statusStageId) {
      handleSnackbar("Please select a stage before choosing a status.", "error");
      return;
    }

    // Task Name + Expert ID without Stage
    if (taskName && expertId && !statusStageId) {
      handleSnackbar("Please select a stage when filtering by Task Name.", "error");
      return;
    }

    let updatedSelectedNewTaskType = new Set(selectedNewTaskType);
    let count = 0;

    // Task name
    if (taskName.length > 0) {
      count += 1;
      updatedSelectedNewTaskType.add("task_name");
    } else {
      updatedSelectedNewTaskType.delete("task_name");
    }

    // Tasker name
    if (taskerName.length > 0) {
      count += 1;
      updatedSelectedNewTaskType.add("tasker_name");
    } else {
      updatedSelectedNewTaskType.delete("tasker_name");
    }

    // Pseudo name
    if (pseudoname.length > 0) {
      count += 1;
      updatedSelectedNewTaskType.add("pseudo_name");
    } else {
      updatedSelectedNewTaskType.delete("pseudo_name");
    }

    // Task allocation / Review allocation
    if (taskAllocation.length > 0 || reviewAllocation.length > 0) {
      count += 1;
      updatedSelectedNewTaskType.add("allocation");
    } else {
      updatedSelectedNewTaskType.delete("allocation");
    }

    // Vendor
    if (vendorId) {
      count += 1;
      updatedSelectedNewTaskType.add("GET_VENDOR_STATUS");
    } else {
      updatedSelectedNewTaskType.delete("GET_VENDOR_STATUS");
    }

    // Status
    if (selectedStatus.length > 0) {
      count += 1;
      updatedSelectedNewTaskType.add("GET_BY_STATUS");
    } else {
      updatedSelectedNewTaskType.delete("GET_BY_STATUS");
    }

    const updatedNewTaskTypeArray = Array.from(updatedSelectedNewTaskType);
    setSelectedNewTaskType(updatedNewTaskTypeArray);
    const payload = {
      task_name: taskName.trim(),
      expert_email: taskAllocation.trim(),
      project_id: id || "",
      page: currentPage,
      pageSize: itemsPerPage,
      paginate: true,
      vendor_id: vendorId,
      // task_allocation_type: buildTypeParam(filterTypes, updatedNewTaskTypeArray),
      ...(selectedStage && { allocated_task_type: "REVIEW" }),
      // statuses: selectedStatus,
      // stage_id: selectedStage,

      // allocated_task_type: selectedTaskType,
      // statuses: statusList ? statusList : selectedStatus,
      // stage_id: selectedStage,
      // expert_id: expertId,
      // gig_source_id: gigSourceId,
      allocated_task_type: selectedTaskType,
      task_allocation_status: statusList ? statusList : selectedStatus,
      stage_id: statusStageId,
      expert: expertId,
      gig_source_id: gigSourceId,
    };
    setAppliedValues({
      ...(taskName && { taskName }),
      ...(statusStageId && { statusStageId }),
      ...(selectedTaskType && { selectedTaskType }),
      statusList: statusList.length > 0 ? statusList : (selectedStatus.length > 0 ? selectedStatus : []),
      ...(expertId && { expertId }),
      ...(gigSourceId && { gigSourceId }),
      ...(vendorId && { vendorId }),
      ...(vendorPseudoName && { vendorPseudoName }),
    });

    dispatch(getUploadTaskPage(payload));
    setAnchorE3(null);
    setFilterCount(count);
    setFilterCountApplied(count);
  };

  useEffect(() => {
    const filters: Filters = {
      taskName,
      taskAllocation,
      reviewAllocation,
      pseudoname,
      selectedVendor,
      selectedTaskType,
      selectedStatus,
    };
    const activeFilters: (keyof Filters)[] = Object.keys(filters).filter(
      (key) => filters[key as keyof Filters] !== ""
    ) as (keyof Filters)[];
    const activeFilterValues = Object.values(filters).filter(
      (value) => value !== ""
    );
  }, [filterTypes]);

  useEffect(() => {
    dispatch(
      getVendorAction({
        search_query: searchTerm.trim(),
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (getVendorStatus === STATUS.SUCESS) {
      setOptions(Vendors.results);
    }
  }, [getVendorStatus]);

  const [pollingTaskId, setPollingTaskId] = useState<string | undefined>(
    undefined
  );

  usePollingTaskStatus({
    status: taskStatusOutputJsonResponse?.data?.status,
    taskId: pollingTaskId,
    onSuccess: () => console.log("Polling finished successfully"),
    onFailure: () => console.log("Polling failed"),
  });

  useEffect(() => {
    const status = taskStatusOutputJsonResponse?.data?.status;
    if (["PENDING", "SUCCESS", "FAILURE"].includes(status)) {
      setOpenTaskStatusModal(true);
    }
  }, [taskStatusOutputJsonResponse]);

  useEffect(() => {
    // Check if status has changed
    const statusHasChanged = getTaskStatusOutputJson !== previousTaskStatusOutputJsonStatus;

    if (
      getTaskStatusOutputJson === STATUS.SUCESS &&
      taskStatusOutputJsonResponse?.data?.url &&
      statusHasChanged
    ) {
      setSnackbarMessage("File Available for download.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      const url = taskStatusOutputJsonResponse.data.url;
      if (typeof url === "string") {
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;

            // ✅ Extract filename
            const filename =
              url.split("/").pop()?.split("?")[0] || "downloaded-file";
            link.download = filename;

            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch(() => alert("Failed to download file"));
      }
    }

    // Only show error if status explicitly changes TO failed (not just intermediate state)
    // Don't show error if the next status might be success (like in polling scenarios)
    if (getTaskStatusOutputJson === STATUS.FAILED && statusHasChanged) {
      // Don't show error message here - let polling recover
    }

    // Update previous status
    setPreviousTaskStatusOutputJsonStatus(getTaskStatusOutputJson);

    return () => {
      if (
        getTaskStatusOutputJson === STATUS.SUCESS ||
        getTaskStatusOutputJson === STATUS.FAILED
      ) {
        dispatch(setTaskStatus(STATUS.NOT_STARTED));
        setPreviousTaskStatusOutputJsonStatus(null);
      }
    };
  }, [
    getTaskStatusOutputJson,
    getTaskStatusOutputJsonMessage,
    taskStatusOutputJsonResponse,
    dispatch,
    previousTaskStatusOutputJsonStatus,
  ]);

  useEffect(() => {
    // Only process if downloadInitiated is true AND the status has actually changed
    if (!downloadInitiated) {
      setPreviousTaskDataStatus(getTaskDataStatus);
      return;
    }

    // Check if status has changed from previous (indicating this is a new response)
    const statusHasChanged = getTaskDataStatus !== previousTaskDataStatus;

    if (getTaskDataStatus === STATUS.SUCESS && statusHasChanged) {
      setSnackbarMessage(getTaskDataMessage);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      const taskId = taskData?.data?.task_id;
      if (taskId) {
        setPollingTaskId(taskId);
        dispatch(getOutputJsonTaskStatus({ celery_task_id: taskId }));
      }

      if (typeof taskData?.data === "string") {
        window.open(taskData.data, "_blank");
      }

      // reset status after handling
      dispatch(setGetTaskDataStatus(STATUS.NOT_STARTED));
      setDownloadInitiated(false);
      setPreviousTaskDataStatus(null);
    }

    if (getTaskDataStatus === STATUS.FAILED && statusHasChanged) {
      setSnackbarMessage(getTaskDataMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);

      dispatch(setGetTaskDataStatus(STATUS.NOT_STARTED));
      setDownloadInitiated(false);
      setPreviousTaskDataStatus(null);
    }

    // Update previous status
    setPreviousTaskDataStatus(getTaskDataStatus);
  }, [getTaskDataStatus, getTaskDataMessage, taskData, dispatch, downloadInitiated]);

  useEffect(() => {
    if (getConfigDataStatus === STATUS.SUCESS) {
      setSnackbarMessage(getConfigDataMessage);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      const taskId = configData?.data?.task_id;
      if (taskId) {
        setPollingTaskId(taskId);
        dispatch(getOutputJsonTaskStatus({ celery_task_id: taskId }));
      }

      if (typeof configData?.data === "string") {
        window.open(configData.data, "_blank");
      }

      // reset status after handling
      dispatch(setGetConfigDataStatus(STATUS.NOT_STARTED));
    }

    if (getConfigDataStatus === STATUS.FAILED) {
      setSnackbarMessage(getConfigDataMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);

      dispatch(setGetConfigDataStatus(STATUS.NOT_STARTED));
    }
  }, [getConfigDataStatus, getConfigDataMessage, configData, dispatch]);

  const debouncedResults = useMemo(() => debounce(handleSearchChange, 300), []);
  const debouncedResultsForAutoComplete = useMemo(() => {
    return debounce(handleSearchChangeAutoComplete, 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });
  useEffect(() => {
    return () => {
      debouncedResultsForAutoComplete.cancel();
    };
  });

  const handleAutocompleteInput = (e: any) => {
    debouncedResultsForAutoComplete(e);
  };

  const handleAutoCompleteOpen = () => {
    setOpenAutoComplete(true);
  };

  const handleAutoCompleteClose = () => {
    setOpenAutoComplete(false);
  };

  const handleVendorAllocation = () => {
    navigate(`/vendorbulkallocation/${id}?vendorbulkallocation`);
  };
  const handleVendorUnallocation = () => {
    navigate(`/vendorbulkunallocation/${id}?vendorbulkunallocation`);
  };

  const handleConfirmClose = () => {
    setDrawer(false);
    setIsUnsavedModalOpen(false);
  };

  const handleCancelClose = () => {
    setIsUnsavedModalOpen(false);
  };

  useEffect(() => {
    const handleCreateQCStatus = () => {
      if (createMetaQCStatus === STATUS.SUCESS) {
        handleSnackbar("Marked as ready for delivery Successfully", "success");
      }
      if (createMetaQCStatus === STATUS.FAILED) {
        handleSnackbar("Error Occured, try again", "error");
      }
    };
    handleCreateQCStatus();
    return () => {
      if (
        createMetaQCStatus === STATUS.SUCESS ||
        createMetaQCStatus === STATUS.FAILED
      ) {
        dispatch(setCreateMetaQC(STATUS.NOT_STARTED));
      }
    };
  }, [createMetaQCStatus]);

  useEffect(() => {
    dispatch(getReview({ project_id: id || "", association_type: "COMPANY" }));
  }, [dispatch, id, association_type]);

  const handleTaskClick = (row: any) => {
    // navigate(`/task/${id}/${row.id}`);
    setDrawer(true);
    setcurrentTaskID(row.id);
  };

  const Stage = reviewStages?.find(
    (s: { id: string }) => s.id === statusStageId
  );
  const category = Stage?.category === "REVIEW" ? "REVIEW" : "TASK";

  const statusOptions =
    category === "REVIEW" ? reviewStatusOptions : taskStatusOptions;

  // const filters: drawerFilter[] = [
  //   {
  //     name: 'taskName',
  //     label: 'Task Name',
  //     type: 'text',
  //     value: taskName,
  //     onChange: setTaskName,
  //     reset: () => setTaskName(''),
  //   },
  //   {
  //     name: 'stage',
  //     label: 'Select stages',
  //     type: 'stages',
  //     value: statusStageId,
  //     onChange: setStatusStageId,
  //     reset: () => setStatusStageId('')
  //   },

  //   {
  //     name: 'statuses',
  //     label: 'Select status',
  //     type: 'multiselect',
  //     options: statusOptions,
  //     value: statusList,
  //     onChange: setStatusList,
  //     reset: () => setStatusList([]),
  //   },
  //   {
  //     name: 'expertId',
  //     label: 'Expert Id',
  //     type: 'text',
  //     value: expertId,
  //     onChange: setExpertId,
  //     reset: () => setExpertId(''),
  //   },
  //   {
  //     name: 'gigSourceId',
  //     label: 'Gig Source Id',
  //     type: 'text',
  //     value: gigSourceId,
  //     onChange: setGigSourceId,
  //     reset: () => setExpertId(''),
  //   },
  //   {
  //     name: 'vendorPseudoName',
  //     label: 'Vendor Pseudoname',
  //     type: 'autocomplete',
  //     value: selectedVendor,
  //     onChange: (vendor: {
  //       pseudo_name: string; vendor_id: string;
  //     }) => {
  //       setVendorId(vendor?.vendor_id || '');
  //       setSelectedVendor(vendor || null);
  //       setVendorPseudoName(vendor?.pseudo_name);
  //     },
  //     reset: () => {
  //       setVendorId('');
  //       setSelectedVendor(null);
  //     },
  //     options,
  //     open: openAutoComplete,
  //     onOpen: handleAutoCompleteOpen,
  //     onClose: handleAutoCompleteClose,
  //     inputValue: selectedVendor != null ? selectedVendor.name : '',
  //     onInputChange: handleAutocompleteInput,
  //     getOptionLabel: (opt: any) =>
  //       opt?.pseudo_name || opt?.vendor_pseudo_name || '',
  //     loading,
  //   },
  // ];

  const handleFetchDetails = (taskAllocationId: string) => async () => {
    if (!taskAllocationId) {
      setErrorMessage("No allocation done yet");
      throw "No allocation available";
    }
    try {
      const result = await dispatch(getTaskExperts({ task_allocation_id: taskAllocationId }) as any).unwrap()

      // Adjust these field mappings based on your actual API response structure
      return [
        { label: "First Name", value: result.first_name || "-" },
        { label: "Last Name", value: result.last_name || "-" },
        { label: "Email", value: result.email || "-" },
        { label: "Gigsource ID", value: result.user_name || "-" },
        { label: "Pseudo Name", value: result.pseudo_name || "-" },
      ]
    } catch (error) {
      throw "Failed to fetch expert details";
    }
  }

  const handleDeleteChip = (key: keyof typeof appliedValues) => {
    const newTaskName = key === "taskName" ? "" : taskName;
    const newSelectedTaskType = key === "stage" ? "" : selectedTaskType;
    const newStatusList = key === "statusList" ? [] : statusList;
    const newExpertId = key === "expertId" ? "" : expertId;
    const newVendorId = key === "vendorPseudoName" ? "" : vendorId;
    const newVendorPseudoName =
      key === "vendorPseudoName" ? "" : vendorPseudoName;

    if (key === "taskName") setTaskName("");
    if (key === "stage") setSelectedTaskType("");
    if (key === "statusList") setStatusList([]);
    if (key === "expertId") setExpertId("");
    if (key === "vendorPseudoName") {
      setVendorId("");
      setVendorPseudoName("");
      setSelectedVendor(null);
    }

    let updatedSelectedNewTaskType = new Set([...selectedNewTaskType]);
    const updatedNewTaskTypeArray = Array.from(updatedSelectedNewTaskType);

    const payload = {
      search: newTaskName.trim() || "",
      project_id: id || "",
      page: currentPage,
      pageSize: itemsPerPage,
      paginate: true,
      vendor_id: newVendorId,
      type: buildTypeParam(filterTypes, updatedNewTaskTypeArray),
      allocated_task_type: newSelectedTaskType,
      statuses: newStatusList,
      stage_id: selectedStage,
      expert_id: newExpertId,
    };
    dispatch(getUploadTaskPage(payload));

    setAppliedValues((curr) => {
      const { [key]: _, ...rest } = curr;
      return rest;
    });
  };

  const handleApply = () => {
    handleApplyClick();
    setOpenDrawerFilter(false);
  };

  const handleResetAll = () => {
    const confirmReset = window.confirm(
      "Are you sure you want to reset all filters? All selected filters will be removed."
    );
    if (confirmReset) {
      const url = window.location.pathname;
      window.history.pushState({}, "", url);
      window.location.reload();
    }
  };
  const activeChips = Object.entries(appliedValues)
    .filter(([key, value]) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== null && value !== undefined && value !== "";
    })
    .map(([key, value]) => {
      let label = "";
      switch (key) {
        case "taskName":
          label = `Task Name: ${value}`;
          break;
        case "stage":
          label = `Stage: ${value}`;
          break;
        case "statusList":
          label = `Status: ${(value as string[]).join(", ").replace("_", " ")}`;
          break;
        case "expertId":
          label = `Expert ID: ${value}`;
          break;
        case "vendorPseudoName":
          label = `Vendor: ${value}`;
          break;
        case "gigSourceId":
          label = `Gig Source ID: ${value}`;
          break;
        default:
          return null;
      }

      return (
        <Chip
          key={key}
          label={label}
          onDelete={() => handleDeleteChip(key as keyof typeof appliedValues)}
          sx={{ mr: 1, mb: 1 }}
        />
      );
    })
    .filter(Boolean);
  const truncateName = (name: string): string => {
    const maxLength = 30;
    if (name.length > maxLength) {
      return `${name.substring(0, maxLength)}...`;
    }
    return name;
  };

  return (
    <>
      <Drawer
        anchor={"right"}
        open={drawer}
        onClose={() => setDrawer(false)}
        PaperProps={{ sx: { width: "70%", padding: "40px" } }}
      >
        <TaskCompleted taskID={currentTaskID} />
      </Drawer>

      <Drawer
        anchor={"right"}
        open={openDrawerFilter}
        onClose={() => setOpenDrawerFilter(false)}
        PaperProps={{ sx: { width: "25%", padding: "40px", paddingTop: "20px" } }}
      >
        <DrawerFilters  
          filters={[
            {
              name: "taskName",
              label: "Task Name",
              type: "text",
              value: taskName,
              onChange: setTaskName,
              reset: () => setTaskName(""),
            },
            {
              name: "stage",
              label: "Select stages",
              type: "stages",
              value: statusStageId,
              onChange: setStatusStageId,
              reset: () => setStatusStageId(""),
            },
            {
              name: "statuses",
              label: "Select status",
              type: "multiselect",
              options: statusOptions,
              value: statusList,
              onChange: setStatusList,
              reset: () => setStatusList([]),
            },
            {
              name: "expertId",
              label: "Expert email / Id",
              type: "text",
              value: expertId,
              onChange: setExpertId,
              reset: () => setExpertId(""),
            },
            {
              name: "gigSourceId",
              label: "Gig Source Id",
              type: "text",
              value: gigSourceId,
              onChange: setGigSourceId,
              reset: () => setGigSourceId(""),
            },
            {
              name: "vendorPseudoName",
              label: "Vendor Pseudoname",
              type: "autocomplete",
              value: selectedVendor,
              onChange: (vendor: {
                pseudo_name: string;
                vendor_id: string;
              }) => {
                setVendorId(vendor?.vendor_id || "");
                setSelectedVendor(vendor || null);
                setVendorPseudoName(vendor?.pseudo_name);
              },
              reset: () => {
                setVendorId("");
                setSelectedVendor(null);
              },
              options,
              open: openAutoComplete,
              onOpen: handleAutoCompleteOpen,
              onClose: handleAutoCompleteClose,
              inputValue: selectedVendor != null ? selectedVendor.name : "",
              onInputChange: handleAutocompleteInput,
              getOptionLabel: (opt: any) =>
                opt?.pseudo_name || opt?.vendor_pseudo_name || "",
              loading,
            },
          ]}
          onApply={handleApply}
          onResetAll={handleResetAll}
          setOpenDrawerFilter={setOpenDrawerFilter}
          stages={getReviewStages?.results || []}
        />
      </Drawer>

      <div
        // className={classes.container}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <div className={classes.actionsContainer}>
          <PaginationEntries
            itemsPerPage={itemsPerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />

          <Box
            sx={{
              display: "flex",
              gap: "15px",
              alignItems: "center",
              marginRight: "20px",
            }}
          >
            <IconButton
              color="primary"
              aria-label="filter options"
              onClick={handleClick}
              value={selectedValue}
              autoFocus={false}
              size="small"
              sx={{
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                background: "linear-gradient(45deg, #42a5f5, #478ed1)",
                borderRadius: "30%",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  background: "linear-gradient(45deg, #478ed1, #42a5f5)",
                  transform: "scale(1.1)",
                },
              }}
            >
              <Tooltip title={"Filters"} placement="bottom-end" arrow>
                <FilterAltIcon fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </IconButton>

            <IconButton
              // fontSize="small"
              onClick={handleMenuClick}
              size="small"
              sx={{
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                background: "linear-gradient(45deg, #42a5f5, #478ed1)",
                borderRadius: "30%",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  background: "linear-gradient(45deg, #478ed1, #42a5f5)",
                  transform: "scale(1.1)",
                },
              }}
            >
              {getTaskDataStatus === STATUS.PENDING ? (
                <CircularProgress size={17} />
              ) : (
                <MoreVertIcon style={{ color: "white" }} />
              )}
            </IconButton>
          </Box>
          {/* <AddButton onClick={handleMenuClick}>Actions</AddButton> */}
          <Divider orientation="vertical" flexItem sx={{ height: "1px" }} />
          <Menu
            id="invite-menu"
            anchorEl={anchorE2}
            open={Boolean(anchorE2)}
            onClose={handleMenuClose}
          >
            {association_type_company && (
              <>
                <MenuItem onClick={() => handleVendorAllocation()}>
                  Vendor Bulk Allocation
                </MenuItem>
                <MenuItem onClick={() => handleVendorUnallocation()}>
                  Vendor Bulk Unallocation
                </MenuItem>
                {/* {fetchPermissions.vendor_unallocation ?.[0] && <MenuItem disabled={!fetchPermissions.vendor_unallocation?.[0]} onClick={() => handleMenuItemClick('Vendor Unallocation')}>Bulk Vendor Unallocation</MenuItem>} */}
                {/* {fetchPermissions.task_allocation?.[0] && (
                  <MenuItem
                    disabled={!fetchPermissions.task_allocation?.[0]}
                    onClick={() => handleMenuItemClick("Task Allocation")}
                  >
                    Bulk Task Allocation
                  </MenuItem>
                )} */}
                {
                  <MenuItem
                    // disabled={!fetchPermissions.task_allocation?.[0]}
                    onClick={() => handleMenuItemClick("Unallocation")}
                  >
                    Bulk Unallocation
                  </MenuItem>
                }
                {/* {fetchPermissions.review_allocation?.[0] && <MenuItem disabled={!fetchPermissions.review_allocation?.[0]} onClick={() => handleMenuItemClick('Review Allocation')}>Bulk Review Allocation</MenuItem>} */}
                {/* {fetchPermissions.review_allocation?.[0] && (
                  <MenuItem
                    onClick={() => handleMenuItemClick("Review Unallocation")}
                  >
                    Bulk Review Unallocation
                  </MenuItem>
                )} */}
                {fetchPermissions.export_data?.[0] && (
                  <MenuItem
                    disabled={!fetchPermissions.export_data?.[0]}
                    onClick={() => handleMenuItemClick("Download Task Data")}
                  >
                    Download Task Data
                  </MenuItem>
                )}
                <MenuItem onClick={() => handleMenuItemClick("Config Data")}>
                  Export Completed Tasks
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("Upload Json")}>
                  Convert JSON to Excel
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("Export Json")}>
                  Export Output Json
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("Upload Task")}>
                  Upload Task
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("Delivered Task")}>
                  Mark Task as Delivered
                </MenuItem>
                <MenuItem
                  onClick={() => handleMenuItemClick("Bulk Task Delete")}
                >
                  Bulk Task Delete
                </MenuItem>
                <MenuItem onClick={() => handleMenuItemClick("Run Script")}>
                  Script Execution
                </MenuItem>
                {/* <MenuItem onClick={handleProjectCloneOpen}>
                  Project clone
                </MenuItem> */}
              </>
            )}
            {association_type_vendor && (
              <>
                {/* {fetchPermissions.vendor_unallocation ?.[0] && <MenuItem disabled={!fetchPermissions.vendor_unallocation?.[0]} onClick={() => handleMenuItemClick('Vendor Unallocation')}>Bulk Vendor Unallocation</MenuItem>} */}
                {/* {fetchPermissions.task_allocation_bulk?.[0] && (
                  <MenuItem
                    disabled={!fetchPermissions.task_allocation_bulk?.[0]}
                    onClick={() => handleMenuItemClick("Task Allocation")}
                  >
                    Bulk Task Allocation
                  </MenuItem>
                )} */}
                {fetchPermissions.task_unallocation_bulk?.[0] && (
                  <MenuItem
                    disabled={!fetchPermissions.task_unallocation_bulk?.[0]}
                    onClick={() => handleMenuItemClick("Unallocation")}
                  >
                    Bulk Unallocation
                  </MenuItem>
                )}
                {/* {fetchPermissions.review_allocation_bulk?.[0] && <MenuItem disabled={!fetchPermissions.review_allocation_bulk?.[0]} onClick={() => handleMenuItemClick('Review Allocation')}>Bulk Review Allocation</MenuItem>} */}
                {/* {fetchPermissions.review_unallocation_bulk?.[0] && (
                  <MenuItem
                    onClick={() => handleMenuItemClick("Review Unallocation")}
                  >
                    Bulk Review Unallocation
                  </MenuItem>
                )} */}
                {fetchPermissions.export_data?.[0] && (
                  <MenuItem
                    disabled={!fetchPermissions.export_data?.[0]}
                    onClick={() => handleMenuItemClick("Download Task Data")}
                  >
                    Download Task Data
                  </MenuItem>
                )}
              </>
            )}
          </Menu>
        </div>
      </div>
      <Box sx={{ pb: 1, display: "flex", flexWrap: "wrap" }}>
        {activeChips.length > 0 ? activeChips : ""}
      </Box>
      <TableContainer sx={{ position: "relative" }}>
        <div
          style={{ marginTop: "0px", marginLeft: "-7px", flexWrap: "wrap" }}
        ></div>

        {getTaskStatus === STATUS.PENDING && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <CircularProgress />
          </div>
        )}
        {!loading && (
          <Table
            sx={{
              width: "100%",
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
            aria-label="simple table"
          >
            <TableHead sx={{ backgroundColor: "#F7F9FA" }}>
              <TableRow>
                {/* TASK column */}
                <TableCell
                  sx={{
                    width: "25%",
                    fontFamily: "Montserrat",
                    fontWeight: 700,
                    fontSize: "12px",
                    lineHeight: "14px",
                    textAlign: "left",
                  }}
                >
                  {`TASK (Count: ${upload.count || 0})`}
                </TableCell>

                {/* Dynamically spaced review stage columns */}
                {reviewStages?.map((stage: any) => (
                  <TableCell
                    key={stage.id}
                    sx={{
                      width: `${75 / reviewStages.length}%`,
                      fontFamily: "Montserrat",
                      fontWeight: 700,
                      fontSize: "12px",
                      lineHeight: "14px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      borderBottom: "1px solid #E0E0E0", // keep consistent divider
                    }}
                  >
                    <Tooltip title={stage.name} arrow>
                      <span>{stage.name}</span>
                    </Tooltip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {getTaskStatus === STATUS.PENDING ? (
                <TableRow>
                  <TableCell colSpan={reviewStages?.length + 1} align="center">
                    <CircularProgress size={17} />
                  </TableCell>
                </TableRow>
              ) : getTaskStatus === STATUS.SUCESS ? (
                upload?.results?.length > 0 ? (
                  upload.results.map((row: any) => (
                    <TableRow
                      key={`${row.id} ${row.task_name}`}
                      sx={{
                        "& td": {
                          borderBottom: "1px solid #E0E0E0", // ensures full divider line
                        },
                      }}
                    >
                      {/* TASK column */}
                      <TableCell
                        sx={{
                          width: "30%",
                          fontFamily: "Montserrat",
                          color: "#10383D",
                          fontWeight: 400,
                          fontSize: "12px",
                          lineHeight: "24px",
                          textAlign: "left",
                          verticalAlign: "middle",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Tooltip title={row.task_name || "-"} arrow>
                            <Box
                              sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "90%",
                              }}
                              onClick={() => handleTaskClick(row)}
                            >
                              {truncateName(row.task_name || "-")}
                            </Box>
                          </Tooltip>
                          <KeyboardArrowRightIcon
                            onClick={() => handleTaskClick(row)}
                            fontSize="small"
                            sx={{ cursor: "pointer", ml: 1 }}
                          />
                        </Box>
                      </TableCell>

                      {/* REVIEW STAGES */}
                      {reviewStages?.map((stage: any) => {
                        const allocation = row.task_allocations?.find(
                          (a: any) => a.stage?.id === stage.id
                        );
                        const status = allocation?.status || "Not Started";
                        return (
                          <TableCellWithPopover
                            key={`${stage.id}-${row.id}`}
                            status={status}
                            icon={getStatusIcon(status)}
                            cellWidth={`${70 / reviewStages.length}%`}
                            onOpen={handleFetchDetails(allocation?.id)}
                            errorMessage={errorMessage}
                          />
                          // <TableCell
                          //   key={stage.id}
                          //   sx={{
                          //     width: `${70 / reviewStages.length}%`,
                          //     fontFamily: "Montserrat",
                          //     color: "#10383D",
                          //     fontWeight: 400,
                          //     fontSize: "12px",
                          //     lineHeight: "24px",
                          //     textAlign: "center",
                          //   }}
                          // >
                          //   <Tooltip title={status} arrow>
                          //     <span>{getStatusIcon(status)}</span>
                          //   </Tooltip>
                          // </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={reviewStages?.length + 1}
                      align="center"
                    >
                      <Error message="There are no tasks added as of yet. You can add a task to see it here." />
                    </TableCell>
                  </TableRow>
                )
              ) : null}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <Stack direction="row" spacing={3} mt={3}>
        {Object.entries(statusIcons).map(([label, icon]) => (
          <Stack direction="row" spacing={1} alignItems="center" key={label}>
            {icon}
            <Typography variant="body2">{label}</Typography>
          </Stack>
        ))}
      </Stack>
      <Dialog open={isUnsavedModalOpen} onClose={handleCancelClose}>
        <div
          style={{
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                style={{
                  fontFamily: "Montserrat",
                  fontWeight: "600",
                  fontSize: "16px",
                  lineHeight: "18px",
                  display: "flex",
                  alignItems: "center",
                  color: "#000000",
                }}
              >
                Unsaved Changes
              </Typography>
            </div>
          </div>
          <Divider style={{ marginBottom: "10px" }} />
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "18px",
              color: "#000000",
              marginTop: "30px",
            }}
          >
            You have unsaved changes. Are you sure you want to leave?
          </Typography>

          <DialogActions>
            <Button
              sx={{
                minWidth: "70px",
                minHeight: "40px",
                backgroundColor: "#F7F9FA",
                padding: "8px 16px",
                gap: "4px",
                ml: "60%",
                borderRadius: "8px",
                "&:hover": { backgroundColor: "#E0E0E0" },
              }}
              onClick={handleCancelClose}
            >
              <Typography
                sx={{
                  fontFamily: "Montserrat",
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#10383D",
                  textTransform: "none",
                }}
              >
                No
              </Typography>
            </Button>
            <Button
              sx={{
                minWidth: "66px",
                minHeight: "40px",
                backgroundColor: "#3D85C6",
                padding: "8px 16px",
                gap: "4px",
                borderRadius: "8px",
                "&:hover": { backgroundColor: "#3D85C6" },
              }}
              onClick={handleConfirmClose}
            >
              <Typography
                sx={{
                  fontFamily: "Montserrat",
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#FFFFFF",
                  textTransform: "none",
                }}
              >
                Yes
              </Typography>
            </Button>
          </DialogActions>
        </div>
      </Dialog>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        paginate={paginate}
        itemsPerPage={itemsPerPage}
      />
      <DeleteModal
        open={showDeleteModal}
        onCancel={cancelDelete}
        onConfirm={confirmDelete}
      />
      <AllocationModal
        open={openModal}
        onClose={handleCloseModal}
        onEmailClick={handleEmailClick}
        taskers={
          allocationType === "TASK" ? filteredTaskers : filteredReviewers
        }
        selectedEmail={selectedEmail}
        searchQuery={searchQuery}
        onSearchChange={handleSearchAllocation}
        onAllocateClick={handleAllocateClick}
        isCheckboxMode={true}
        selectedIds={selectedIds}
        allocationType={allocationType}
      // taskers={taskers}
      // onSearchChange={handleSearchAllocation}
      // searchQuery={searchQuery}
      />
      <InfoModal
        open={openInfoModal}
        onClose={handleCloseInfoModal}
        selectedIds={selectedIds}
        onNextClick={handleNextClick}
      />
      <InfoModalReview
        open={openInfoModalReview}
        onClose={handleCloseInfoModalReview}
        selectedIds={selectedIds}
        onNextClick={handleNextClick}
      />

      <InfoModelTaskUnallocation
        open={open}
        setOpen={setOpen}
        openTaskUnallocationModel={openTaskUnallocationModel}
        openReviewUnallocationModel={openReviewUnallocationModel}
        setOpenTaskUnallocationModel={setOpenTaskUnallocationModel}
        setOpenReviewUnallocationModel={setOpenReviewUnallocationModel}
      />

      <ConfirmationDialog
        open={openConfirmationDialog}
        onClose={handleCancelConfirmation}
        onConfirm={handleConfirmAllocation}
      />
      <SnackbarNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      <TaskStatusModal
        open={openTaskStatusModal}
        onClose={() => setOpenTaskStatusModal(false)}
        taskStatusData={taskStatusOutputJsonResponse?.data}
        completedTaskExported={true}
      />
      <ExportCompletedTasksDialog
        open={openExportDialog}
        onClose={handleExportDialogClose}
        projectId={id!}
        configs={configData?.data?.configs || []}
        stages={getReviewStages?.results || []}
        vendors={Vendors.results || []}
        onSubmit={(formValues: any) => {
          // call your export API, passing `formValues` + any other required params
          // dispatch(exportCompletedTasks({ project_id: id, ...formValues }))
          handleExportDialogClose();
        }}
      />
      <ExportTaskDialog
        open={openNewExportDialog}
        onClose={() => setOpenNewExportDialog(false)}
      />
    </>
  );
};

export default TaskUploadTable;
